import moment from "moment";

moment.locale("fr");

export default moment;
